export default __webpack_public_path__ + "static/media/mbd.58291f27.svg";